import { render, staticRenderFns } from "./LucidActivities.vue?vue&type=template&id=2067922e"
import script from "./LucidActivities.vue?vue&type=script&lang=js"
export * from "./LucidActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports